"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkBYIEAVCXjs = require('./chunk-BYIEAVCX.js');





var _chunkQ4G2SZRDjs = require('./chunk-Q4G2SZRD.js');

// node_modules/@yandex-int/error-counter/dist/logError.js
var require_logError = _chunkQ4G2SZRDjs.__commonJS.call(void 0, {
  "node_modules/@yandex-int/error-counter/dist/logError.js"() {
    "use strict";
    (function() {
      "use strict";
      (function(rum) {
        rum.logError = function(params, error, settingsFromError) {
          params = params || {};
          if (typeof error === "string" || typeof error === "undefined") {
            error = new Error(error);
            error.justCreated = true;
          }
          var message = params.message || "", err = rum._baseNormalizeError(error);
          if (err.message && !params.ignoreErrorMessage) {
            if (message) {
              message += "; ";
            }
            message += err.message;
          }
          err.message = message || "Empty error";
          var fields = ["service", "source", "type", "block", "additional", "level", "page", "method", "sourceMethod", "coordinates_gp"];
          for (var i = 0; i < fields.length; i++) {
            var name = fields[i];
            if (params[name]) {
              err[name] = params[name];
            } else if (error && error[name]) {
              err[name] = error[name];
            }
          }
          rum._handleError(err, true, settingsFromError);
        };
      })(Ya.Rum);
    })();
  }
});

// node_modules/@yandex-int/error-counter/dist/implementation.js
var require_implementation = _chunkQ4G2SZRDjs.__commonJS.call(void 0, {
  "node_modules/@yandex-int/error-counter/dist/implementation.js"() {
    "use strict";
    (function(window2, rum) {
      var PATH_CLIENT_ERROR = "690.2354";
      var PATH_UNCAUGHT_ERROR = "690.2361";
      var PATH_EXTERNAL_ERROR = "690.2854";
      var PATH_SCRIPT_ERROR = "690.2609";
      var LIMIT_CLIENT_ERROR = 1e3;
      var LIMIT_UNCAUGHT_ERROR = 100;
      var LIMIT_EXTERNAL_ERROR = 100;
      var LIMIT_SCRIPT_ERROR = 100;
      var SILENT_LIMIT_CLIENT_ERROR = 100;
      var SILENT_LIMIT_UNCAUGHT_ERROR = 10;
      var SILENT_LIMIT_EXTERNAL_ERROR = 10;
      var SILENT_LIMIT_SCRIPT_ERROR = 10;
      var types = {
        // type: [path, limit, silentLimit, sent]
        client: [PATH_CLIENT_ERROR, LIMIT_CLIENT_ERROR, SILENT_LIMIT_CLIENT_ERROR, 0],
        uncaught: [PATH_UNCAUGHT_ERROR, LIMIT_UNCAUGHT_ERROR, SILENT_LIMIT_UNCAUGHT_ERROR, 0],
        external: [PATH_EXTERNAL_ERROR, LIMIT_EXTERNAL_ERROR, SILENT_LIMIT_EXTERNAL_ERROR, 0],
        script: [PATH_SCRIPT_ERROR, LIMIT_SCRIPT_ERROR, SILENT_LIMIT_SCRIPT_ERROR, 0]
      };
      var pending = {};
      rum.ERROR_LEVEL = {
        INFO: "info",
        DEBUG: "debug",
        WARN: "warn",
        ERROR: "error",
        FATAL: "fatal"
      };
      rum._errorSettings = {
        clck: "https://yandex.ru/clck/click",
        beacon: true,
        project: "unknown",
        page: "",
        env: "",
        experiments: [],
        additional: {},
        platform: "",
        // регион из геобазы
        region: "",
        dc: "",
        host: "",
        service: "",
        level: "",
        version: "",
        yandexuid: "",
        loggedin: false,
        coordinates_gp: "",
        referrer: true,
        preventError: false,
        unhandledRejection: false,
        traceUnhandledRejection: false,
        uncaughtException: true,
        debug: false,
        limits: {},
        silent: {},
        filters: {},
        pageMaxAge: 10 * 24 * 60 * 60 * 1e3,
        initTimestamp: +/* @__PURE__ */ new Date()
      };
      var inited = false;
      rum.initErrors = function(settings) {
        var errorSettings = objectExtend(rum._errorSettings, settings);
        if (inited) {
          return;
        }
        if (errorSettings.uncaughtException) {
          subscribe();
        }
        if (errorSettings.unhandledRejection && errorSettings.traceUnhandledRejection && rum._traceUnhandledRejection) {
          rum._traceUnhandledRejection();
        }
        inited = true;
      };
      rum.updateErrors = function(settings) {
        objectExtend(rum._errorSettings, settings);
      };
      rum.updateAdditional = function(additional) {
        rum._errorSettings.additional = objectExtend(rum._errorSettings.additional || {}, additional);
      };
      rum._handleError = function(event, isCustom, settingsFromError) {
        var settings = rum._errorSettings;
        if (settings.preventError && event.preventDefault) {
          event.preventDefault();
        }
        var error, errorType;
        if (!isCustom) {
          error = rum._normalizeError(event);
          errorType = error.type;
          var onError = settings.onError;
          if (typeof onError === "function") {
            onError(error);
          }
          var transform = settings.transform;
          if (typeof transform === "function") {
            error = transform(error);
          }
          if (!error) {
            return;
          }
          if (error.settings) {
            settingsFromError = error.settings;
          }
        } else {
          error = event;
          errorType = "client";
        }
        var currentTimestamp = +/* @__PURE__ */ new Date();
        var initTimestamp = settings.initTimestamp;
        var pageMaxAge = settings.pageMaxAge;
        if (pageMaxAge !== -1 && initTimestamp && initTimestamp + pageMaxAge < currentTimestamp) {
          return;
        }
        var limit = types[errorType][1];
        if (typeof settings.limits[errorType] === "number") {
          limit = settings.limits[errorType];
        }
        var silentLimit = types[errorType][2];
        if (typeof settings.silent[errorType] === "number") {
          silentLimit = settings.silent[errorType];
        }
        var sent = types[errorType][3];
        if (sent < limit || limit === -1) {
          error.path = types[errorType][0];
          var sendData = rum._getErrorData(error, {
            silent: sent < silentLimit || silentLimit === -1 ? "no" : "yes",
            isCustom: Boolean(isCustom)
          }, objectExtend(objectExtend({}, settings), settingsFromError));
          var send = function(sendData2) {
            pending[error.message] = false;
            rum._sendError(sendData2.path, sendData2.vars);
            types[errorType][3]++;
          }.bind(this, sendData);
          if (typeof settings.throttleSend === "undefined") {
            send();
          } else {
            if (pending[error.message]) {
              return;
            }
            pending[error.message] = true;
            setTimeout(send, settings.throttleSend);
          }
        }
      };
      rum._getReferrer = function(settings) {
        var settingsReferrer = settings.referrer;
        var typeOfSettingsReferrer = typeof settingsReferrer;
        if (typeOfSettingsReferrer === "function") {
          return settingsReferrer();
        }
        if (typeOfSettingsReferrer === "string" && settingsReferrer) {
          return settingsReferrer;
        }
        if (settingsReferrer === false) {
          return void 0;
        }
        return window2.location ? window2.location.href : void 0;
      };
      rum.getErrorSetting = function(key) {
        return rum._errorSettings[key];
      };
      rum._buildExperiments = function(settingsExperiments) {
        return settingsExperiments instanceof Array ? settingsExperiments.join(";") : "";
      };
      rum._buildAdditional = function(settingsAdditional, paramsAdditional) {
        var additional = "";
        try {
          var additionalObject = objectExtend(objectExtend({}, settingsAdditional), paramsAdditional);
          if (Object.keys(additionalObject).length !== 0) {
            additional = JSON.stringify(additionalObject);
          }
        } catch (e) {
        }
        return additional;
      };
      rum._getErrorData = function(err, params, settings) {
        params = params || {};
        var experiments = rum._buildExperiments(settings.experiments);
        var additional = rum._buildAdditional(settings.additional, err.additional);
        var vars = {
          // генерится браузером
          "-stack": err.stack,
          "-url": err.file,
          "-line": err.line,
          "-col": err.col,
          // блок, в котором произошла ошибка
          "-block": err.block,
          // метод, в котором произошла ошибка
          "-method": err.method,
          // заполняется в событии браузера или передается вручную
          "-msg": err.message,
          // окружение
          "-env": settings.env,
          // вспомогательные поля для понимания типа внешних ошибок
          "-external": err.external,
          "-externalCustom": err.externalCustom,
          // принадлежность к сервису
          "-project": settings.project,
          "-service": err.service || settings.service,
          "-page": err.page || settings.page,
          // платформа
          "-platform": settings.platform,
          // критичность
          "-level": err.level,
          // эксперименты
          "-experiments": experiments,
          // версия статики
          "-version": settings.version,
          // регион
          "-region": settings.region,
          // датацентр
          "-dc": settings.dc,
          // имя хоста
          "-host": settings.host,
          // id пользователя
          "-yandexuid": settings.yandexuid,
          // залогинен ли пользователь
          "-loggedin": settings.loggedin,
          // кука с кооординатами
          "-coordinates_gp": err.coordinates_gp || settings.coordinates_gp,
          "-referrer": rum._getReferrer(settings),
          // источник ошибки
          "-source": err.source,
          // метод/ручка источника ошибки
          "-sourceMethod": err.sourceMethod,
          // тип ошибки
          // logic, render, network, ...
          "-type": params.isCustom ? err.type : "",
          // хэш с дополнительными параметрами
          "-additional": additional,
          // наличие блокировщиков рекламы
          "-adb": castBlocker(Ya.blocker) || castBlocker(settings.blocker),
          // CDN из https://yastatic.net/nearest.js
          "-cdn": window2.YaStaticRegion,
          // ua - попробуем брать из кук
          "-ua": navigator.userAgent,
          // если кол-во ошибок от 1 пользователя слишком большое, тогда отсылаем признак,
          // чтобы отфильтровывать эти ошибки в Голован
          "-silent": params.silent,
          // клиентское время ошибки
          "-ts": +/* @__PURE__ */ new Date(),
          "-init-ts": settings.initTimestamp
        };
        if (settings.debug && window2.console) {
          console[console[err.level] ? err.level : "error"]("[error-counter] " + err.message, vars, err.stack);
        }
        return {
          path: err.path,
          vars
        };
      };
      function objectExtend(target, object) {
        for (var name in object) {
          if (object.hasOwnProperty(name)) {
            target[name] = object[name];
          }
        }
        return target;
      }
      rum._baseNormalizeError = function(err) {
        err = err || {};
        var error = err.error;
        var file = err.filename || err.fileName || "";
        var stack = error && error.stack || err.stack || "";
        var message = err.message || "";
        var additional = error && error.additional || err.additional;
        return {
          file,
          line: err.lineno || err.lineNumber,
          col: err.colno || err.colNumber,
          stack,
          message,
          additional
        };
      };
      rum._normalizeError = function(err) {
        var error = rum._baseNormalizeError(err);
        var type = "uncaught";
        var externalParams = rum._isExternalError(error.file, error.message, error.stack);
        var externalParamsCommon = "";
        var externalParamsCustom = "";
        if (externalParams.hasExternal) {
          type = "external";
          externalParamsCommon = externalParams.common;
          externalParamsCustom = externalParams.custom;
        } else if (/^Script error\.?$/.test(error.message)) {
          type = "script";
        }
        error.external = externalParamsCommon;
        error.externalCustom = externalParamsCustom;
        error.type = type;
        return error;
      };
      rum._createVarsString = function(vars) {
        var varsArr = [];
        for (var key in vars) {
          if (vars.hasOwnProperty(key) && (vars[key] || vars[key] === 0)) {
            varsArr.push(key + "=" + encodeURIComponent(vars[key]).replace(/\*/g, "%2A"));
          }
        }
        return varsArr.join(",");
      };
      function castBlocker(value) {
        if (typeof value === "boolean") {
          value = +value;
        }
        if (typeof value === "number") {
          return value + "";
        }
        return null;
      }
      rum._sendError = function(path, vars) {
        rum.send(null, path, rum._createVarsString(vars), null, null, null, null);
      };
      var handleError = function(event) {
        rum._handleError(event, false);
      };
      var handleResourceLoadFailure = function(event) {
        var target = event.target;
        if (!target) {
          return;
        }
        var url = target.srcset || target.src;
        if (!url) {
          url = target.href;
        }
        if (!url) {
          return;
        }
        var tag = target.tagName || "UNKNOWN";
        rum.logError({
          message: tag + " load error",
          additional: { src: url }
        });
      };
      rum._parseTraceablePromiseStack = function() {
      };
      function subscribe() {
        var errorSettings = rum._errorSettings;
        if (window2.addEventListener) {
          window2.addEventListener("error", handleError);
          if (errorSettings.resourceFails) {
            window2.addEventListener("error", handleResourceLoadFailure, true);
          }
          if ("Promise" in window2 && errorSettings.unhandledRejection) {
            window2.addEventListener("unhandledrejection", function(event) {
              var reason = event.reason;
              var message, stack, additional = {};
              if (reason) {
                if (reason.stack && reason.message) {
                  message = reason.message;
                  stack = reason.stack;
                } else {
                  message = String(reason);
                  stack = rum._parseTraceablePromiseStack(event.promise);
                  if (message === "[object Event]") {
                    message = "event.type: " + reason.type;
                  } else if (message === "[object Object]") {
                    additional.unhandledObject = reason;
                  }
                }
                if (reason.target && reason.target.src) {
                  additional.src = reason.target.src;
                }
                handleError({
                  message: "Unhandled rejection: " + message,
                  stack,
                  additional
                });
              }
            });
          }
        } else {
          var oldOnError = window2.onerror;
          window2.onerror = function(message, file, lineNumber, columnNumber, error) {
            handleError({
              error: error || new Error(message || "Empty error"),
              message,
              lineno: lineNumber,
              colno: columnNumber,
              filename: file
            });
            if (oldOnError) {
              oldOnError.apply(this, arguments);
            }
          };
        }
      }
    })(typeof self !== "undefined" ? self : window, Ya.Rum);
  }
});

// node_modules/@yandex-int/rum-counter/dist/bundle/implementation.js
var require_implementation2 = _chunkQ4G2SZRDjs.__commonJS.call(void 0, {
  "node_modules/@yandex-int/rum-counter/dist/bundle/implementation.js"() {
    "use strict";
    (function(rum, undefined2) {
      if (!rum) {
        throw new Error("Rum: interface is not included");
      }
      if (!rum.enabled) {
        rum.getSetting = function() {
          return "";
        };
        rum.getVarsList = function() {
          return [];
        };
        rum.getResourceTimings = rum.pushConnectionTypeTo = rum.pushTimingTo = rum.normalize = rum.sendCounter = rum.sendDelta = rum.sendTimeMark = rum.sendResTiming = rum.sendTTI = rum.makeSubPage = rum.sendHeroElement = rum.onReady = rum.onQuietWindow = function() {
        };
        return;
      }
      rum.getVarsList = function() {
        var vars = rum._vars;
        return Object.keys(vars).map(function(varName) {
          return varName + "=" + encodeURIComponent(vars[varName]).replace(/\*/g, "%2A");
        });
      };
      rum.setVars = function(vars) {
        Object.keys(vars).forEach(function(k) {
          rum._vars[k] = vars[k];
        });
        updateCommonVars();
        updateMarkCommonVars();
      };
      var PATH_TECH_TIMING = "690.1033";
      var PATH_TIME = "690.2096.207";
      var PATH_DELTA = "690.2096.2877";
      var PATH_NAVIGATION = "690.2096.2892";
      var PATH_RESOURCE_TIMING = "690.2096.2044";
      var TECH_PERF_TRAFFIC = "690.2096.361";
      var TECH_PERF_CLS = "690.2096.4004";
      var POLLING_ITERATIONS_LIMIT = 3;
      var LONG_TASK_TIMEOUT = 3e3;
      var COMMON_TIMING_PROPS_MAP = {
        connectEnd: 2116,
        connectStart: 2114,
        decodedBodySize: 2886,
        domComplete: 2124,
        domContentLoadedEventEnd: 2131,
        domContentLoadedEventStart: 2123,
        domInteractive: 2770,
        domLoading: 2769,
        domainLookupEnd: 2113,
        domainLookupStart: 2112,
        duration: 2136,
        encodedBodySize: 2887,
        entryType: 2888,
        fetchStart: 2111,
        initiatorType: 2889,
        loadEventEnd: 2126,
        loadEventStart: 2125,
        nextHopProtocol: 2890,
        redirectCount: 1385,
        redirectEnd: 2110,
        redirectStart: 2109,
        requestStart: 2117,
        responseEnd: 2120,
        responseStart: 2119,
        secureConnectionStart: 2115,
        startTime: 2322,
        transferSize: 2323,
        type: 76,
        unloadEventEnd: 2128,
        unloadEventStart: 2127,
        workerStart: 2137
      };
      var VISIBILITY_STATES = {
        visible: 1,
        hidden: 2,
        prerender: 3
      };
      var CONNECTION_TYPES = {
        bluetooth: 2064,
        cellular: 2065,
        ethernet: 2066,
        none: 1229,
        wifi: 2067,
        wimax: 2068,
        other: 861,
        unknown: 836,
        // Legacy
        "0": 836,
        // unknown
        "1": 2066,
        // ethernet
        "2": 2067,
        // wifi
        "3": 2070,
        // 2G
        "4": 2071,
        // 3G
        "5": 2768
        // 4G
      };
      var PAINT_TYPES = {
        "first-paint": 2793,
        "first-contentful-paint": 2794
      };
      var PAINT_EVENTS_COUNT = Object.keys(PAINT_TYPES).length;
      var getTime = rum.getTime;
      var PerfObserver = window.PerformanceObserver;
      var perf = window.performance || {};
      var pageTiming = perf.timing || {};
      var navigation = perf.navigation || {};
      var connection = navigator.connection;
      var timeMarks = {};
      var trafficDataBuffer = {};
      var deltaMarks = rum._deltaMarks;
      var normalizeLink = document.createElement("link");
      var normalizeAnchor = document.createElement("a");
      var hasGetEntriesByType = typeof perf.getEntriesByType === "function";
      var navStart = pageTiming.navigationStart;
      var commonVars, markCommonVars;
      updateCommonVars();
      updateMarkCommonVars();
      rum.ajaxStart = 0;
      rum.ajaxComplete = 0;
      function updateCommonVars() {
        commonVars = rum.getVarsList();
        if (rum.getSetting("sendClientUa")) {
          commonVars.push("1042=" + encodeURIComponent(navigator.userAgent));
        }
      }
      function updateMarkCommonVars() {
        markCommonVars = commonVars.concat([
          "143.2129=" + navStart
          // page.navigation_start
        ]);
      }
      onReady(main);
      rum._getCommonVars = function() {
        return commonVars;
      };
      function onReady(cb) {
        function wrappedCb() {
          removeEventListener("DOMContentLoaded", wrappedCb);
          removeEventListener("load", wrappedCb);
          cb();
        }
        if (document.readyState === "loading") {
          addEventListener("DOMContentLoaded", wrappedCb);
          addEventListener("load", wrappedCb);
        } else {
          cb();
        }
      }
      function main() {
        if (!navStart) {
          return;
        }
        setTimeout(function() {
          rum.sendTimeMark = sendTimeMark;
          rum.sendResTiming = sendResTiming;
          rum.timeEnd = timeEnd;
          var defRes = rum._defRes;
          while (defRes.length) {
            var resData = defRes.shift();
            sendResTiming(resData[0], resData[1]);
          }
          var defTimes = rum._defTimes;
          while (defTimes.length) {
            var timeData = defTimes.shift();
            sendTimeMark(timeData[0], timeData[1], false, timeData[2]);
          }
          Object.keys(deltaMarks).forEach(function(counterId) {
            sendDelta(counterId);
          });
          sendPageLoadingTiming();
          sendPaintTiming();
          if (rum.getSetting("sendAutoElementTiming")) {
            sendElementTiming();
          }
          checkLongTasks();
          if (document.readyState === "complete") {
            runOnLoadTasks();
          } else {
            addEventListener("load", runOnLoadTasks);
          }
        }, 0);
      }
      function runOnLoadTasks() {
        if (rum.getSetting("disableOnLoadTasks")) {
          return;
        }
        removeEventListener("load", runOnLoadTasks);
        initPeriodicStats();
        initTrafficStats();
        sendFirstInputDelay();
        sendNavigationTiming();
        calcLayoutShiftScore();
        calcLargestContentfulPaint();
      }
      function sendNavigationTiming() {
        if (!hasGetEntriesByType)
          return;
        var navigationTiming = perf.getEntriesByType("navigation")[0];
        if (navigationTiming) {
          var vars = [];
          pushTimingTo(vars, navigationTiming);
          pushConnectionTypeTo(vars);
          var yabrowserNavigationSource = perf.getEntriesByName("yndxNavigationSource")[0];
          if (yabrowserNavigationSource) {
            vars.push("2091.186=" + yabrowserNavigationSource.value);
          }
          sendCounter(PATH_NAVIGATION, commonVars.concat(vars));
        }
      }
      function sendPageLoadingTiming() {
        var domContentLoadedEventStart = pageTiming.domContentLoadedEventStart, domContentLoadedEventEnd = pageTiming.domContentLoadedEventEnd;
        if (domContentLoadedEventStart === 0 && domContentLoadedEventEnd === 0) {
          setTimeout(sendPageLoadingTiming, 50);
          return;
        }
        var responseStart = pageTiming.responseStart === 0 ? navStart : pageTiming.responseStart;
        var domainLookupStart = pageTiming.domainLookupStart === 0 ? navStart : pageTiming.domainLookupStart;
        var vars = commonVars.concat([
          // [navigation_start] Время старта запроса
          "2129=" + navStart,
          // [wait] Время ожидания перед запросом
          "1036=" + (domainLookupStart - navStart),
          // [dns] Время DNS Lookup
          // в IFRAME оба будут равны 0, коррекция на navStart не нужна
          "1037=" + (pageTiming.domainLookupEnd - pageTiming.domainLookupStart),
          // [tcp] Время TCP Handshake
          "1038=" + (pageTiming.connectEnd - pageTiming.connectStart),
          // [ssl] Время установки безопасного соединения
          pageTiming.secureConnectionStart && "1383=" + (pageTiming.connectEnd - pageTiming.secureConnectionStart),
          // [ttfb] Время до первого байта
          // в IFRAME оба будут равны 0, коррекция на navStart не нужна
          "1039=" + (pageTiming.responseStart - pageTiming.connectEnd),
          // [html] Время получения HTML от первого байта
          "1040=" + (pageTiming.responseEnd - responseStart),
          // [html.total] Время получения HTML от DNS Lookup
          "1040.906=" + (pageTiming.responseEnd - domainLookupStart),
          // [dom.loading] Время начала парсинга HTML от первого байта
          "1310.2084=" + (pageTiming.domLoading - responseStart),
          // [dom.interactive] Время окончания парсинга HTML от первого байта
          "1310.2085=" + (pageTiming.domInteractive - responseStart),
          // [dom.init] Время выполнения DOMContentLoaded
          "1310.1309=" + (domContentLoadedEventEnd - domContentLoadedEventStart),
          // [dom.loaded] Время начала DOMContentLoaded от первого байта
          "1310.1007=" + (domContentLoadedEventStart - responseStart),
          // [device_memory] Объём памяти устройства, см. https://github.com/w3c/device-memory
          navigator.deviceMemory && "3140=" + navigator.deviceMemory,
          // [hardware_concurrency] Количество ядер, см. https://clck.ru/DYqo9
          navigator.hardwareConcurrency && "3141=" + navigator.hardwareConcurrency
        ]);
        Object.keys(COMMON_TIMING_PROPS_MAP).forEach(function(name) {
          if (name in pageTiming && pageTiming[name]) {
            vars.push(COMMON_TIMING_PROPS_MAP[name] + "=" + normalize(pageTiming[name], navStart));
          }
        });
        if (rum.vsStart) {
          vars.push("1484=" + (VISIBILITY_STATES[rum.vsStart] || 2771));
          if (rum.vsChanged) {
            vars.push("1484.719=1");
          }
        } else {
          vars.push("1484=" + VISIBILITY_STATES.visible);
        }
        if (navigation) {
          if (navigation.redirectCount) {
            vars.push("1384.1385=" + navigation.redirectCount);
          }
          if (navigation.type === 1 || navigation.type === 2) {
            vars.push("770.76=" + navigation.type);
          }
        }
        pushConnectionTypeTo(vars);
        sendCounter(PATH_TECH_TIMING, vars);
      }
      var paintEventsSent = {};
      var paintEventsSentCount = 0;
      function sendPaintTiming() {
        if (!hasGetEntriesByType || !rum.getSetting("forcePaintTimeSending") && rum.isVisibilityChanged()) {
          return;
        }
        var paintEvents = perf.getEntriesByType("paint");
        for (var i = 0; i < paintEvents.length; i++) {
          var event = paintEvents[i];
          var paintType = PAINT_TYPES[event.name];
          if (paintType && !paintEventsSent[event.name]) {
            paintEventsSent[event.name] = true;
            paintEventsSentCount++;
            sendTimeMark("1926." + paintType, event.startTime);
          }
        }
        if (paintEventsSentCount < PAINT_EVENTS_COUNT) {
          try {
            new PerfObserver(function(list, observer) {
              sendPaintTiming();
              if (observer) {
                observer.disconnect();
              }
            }).observe({ entryTypes: ["paint"] });
          } catch (e) {
          }
        }
      }
      function sendTimeMark(counterId, time, addPerfMark, params) {
        if (time === undefined2) {
          time = getTime();
        }
        if (addPerfMark === undefined2 || addPerfMark === true) {
          rum.mark(counterId, time);
        }
        var vars = getMarkCommonVars(counterId);
        vars.push("207=" + normalize(time));
        if (!addCustomParamsToVars(vars, params)) {
          return;
        }
        sendCounter(PATH_TIME, vars);
        timeMarks[counterId] = timeMarks[counterId] || [];
        timeMarks[counterId].push(time);
        var listeners = rum._markListeners[counterId];
        if (listeners && listeners.length) {
          listeners.forEach(function(cb) {
            cb(time);
          });
        }
      }
      function addCustomParamsToVars(vars, params) {
        if (params) {
          if (params.isCanceled && params.isCanceled()) {
            return false;
          }
          var key2IdxMap = vars.reduce(function(acc, el, idx) {
            if (typeof el === "string") {
              var key = el.split("=")[0];
              acc[key] = idx;
            }
            return acc;
          }, {});
          Object.keys(params).forEach(function(paramName) {
            if (typeof params[paramName] !== "function") {
              var idx = key2IdxMap[paramName], value = paramName + "=" + params[paramName];
              if (idx === undefined2) {
                vars.push(value);
              } else {
                vars[idx] = value;
              }
            }
          });
        }
        return true;
      }
      rum.getTimeMarks = function() {
        return timeMarks;
      };
      function timeEnd(counterId, params) {
        var deltaTimes = deltaMarks[counterId];
        if (!deltaTimes || deltaTimes.length === 0) {
          return;
        }
        deltaTimes.push(getTime(), params);
        sendDelta(counterId);
      }
      function sendDelta(counterId, delta, params) {
        var deltaTimes = deltaMarks[counterId], deltaStart, deltaEnd, deltaVars;
        if (typeof delta !== "undefined") {
          deltaEnd = rum.getTime();
          deltaStart = deltaEnd - delta;
        } else if (deltaTimes) {
          deltaStart = deltaTimes[0];
          deltaEnd = deltaTimes[1];
          deltaVars = deltaTimes[2];
        }
        if (deltaStart === undefined2 || deltaEnd === undefined2) {
          return;
        }
        var vars = getMarkCommonVars(counterId);
        vars.push(
          "207.2154=" + normalize(deltaStart),
          // time.start
          "207.1428=" + normalize(deltaEnd),
          // time.end
          "2877=" + normalize(deltaEnd - deltaStart)
          // delta
        );
        if (addCustomParamsToVars(vars, params) && addCustomParamsToVars(vars, deltaVars)) {
          sendCounter(PATH_DELTA, vars);
          delete deltaMarks[counterId];
        }
      }
      function sendResTiming(counterId, url) {
        getResourceTimings(url, function(resTimings) {
          if (resTimings) {
            var vars = getMarkCommonVars(counterId);
            if (rum.getSetting("sendUrlInResTiming")) {
              vars.push("13=" + encodeURIComponent(url));
            }
            var timing = resTimings[resTimings.length - 1];
            pushTimingTo(vars, timing);
            sendCounter(PATH_RESOURCE_TIMING, vars);
          }
        });
      }
      var periodicCounterIntervalId;
      rum._periodicTasks = [];
      function initPeriodicStats() {
        var interval = rum.getSetting("periodicStatsIntervalMs");
        if (!interval && interval !== null) {
          interval = 15e3;
        }
        if (interval) {
          periodicCounterIntervalId = setInterval(periodicStatsTick, interval);
        }
        addEventListener("beforeunload", periodicStatsTick);
      }
      function periodicStatsTick() {
        var used = false;
        rum._periodicTasks.forEach(function(task) {
          if (task()) {
            used = true;
          }
        });
        if (!used) {
          clearInterval(periodicCounterIntervalId);
        }
      }
      var trafficCounterSentCount = 0;
      function initTrafficStats() {
        if (!PerfObserver) {
          return;
        }
        var doc = perf.getEntriesByType("navigation");
        writeTrafficData(doc);
        var resources = perf.getEntriesByType("resource");
        writeTrafficData(resources);
        try {
          new PerfObserver(function(entryList) {
            writeTrafficData(entryList.getEntries());
          }).observe({ entryTypes: ["resource", "navigation"] });
        } catch (e) {
        }
        rum._periodicTasks.push(sendTrafficData);
      }
      function writeTrafficData(entries) {
        if (!entries || !entries.length) {
          return;
        }
        var db = trafficDataBuffer;
        for (var i = 0; i < entries.length; i++) {
          var entryData = getTrafficEntryData(entries[i]);
          if (!entryData) {
            continue;
          }
          var groupKey = entryData.domain + "-" + entryData.extension;
          var buf = db[groupKey] = db[groupKey] || {
            count: 0,
            size: 0
          };
          buf.count++;
          buf.size += entryData.size;
        }
      }
      function getTrafficEntryData(entry) {
        var size = entry.transferSize;
        if (size == null) {
          return;
        }
        normalizeAnchor.href = entry.name;
        var pathname = normalizeAnchor.pathname;
        if (pathname.indexOf("/clck") === 0) {
          return;
        }
        var lastDotPath = pathname.lastIndexOf(".");
        var extension = "";
        if (lastDotPath !== -1 && pathname.lastIndexOf("/") < lastDotPath && pathname.length - lastDotPath <= 5) {
          extension = pathname.slice(lastDotPath + 1);
        }
        return {
          size,
          domain: normalizeAnchor.hostname,
          extension
        };
      }
      function sendTrafficData() {
        var maxCounters = rum.getSetting("maxTrafficCounters") || 250;
        if (trafficCounterSentCount >= maxCounters) {
          return false;
        }
        var groupKeys = Object.keys(trafficDataBuffer);
        var value = "";
        for (var i = 0; i < groupKeys.length; i++) {
          var groupKey = groupKeys[i];
          var groupData = trafficDataBuffer[groupKey];
          value += encodeURIComponent(groupKey) + "!" + groupData.count + "!" + groupData.size + ";";
        }
        if (value.length) {
          trafficCounterSentCount++;
          var currentVars = commonVars.concat(["d=" + value, "t=" + normalize(getTime())]);
          sendCounter(TECH_PERF_TRAFFIC, currentVars);
        }
        trafficDataBuffer = {};
        return trafficCounterSentCount < maxCounters;
      }
      function sendFirstInputDelay() {
        if (!PerfObserver) {
          return;
        }
        try {
          new PerfObserver(function(entryList, observer) {
            var entry = entryList.getEntries()[0];
            if (!entry) {
              return;
            }
            var processingStart = entry.processingStart;
            var params = {
              // Полная длительность события, от момента получения браузером события из ОС
              // до отрисовки следующего фрейма после выполнения всех обработчиков события.
              duration: entry.duration,
              // Время на выполнение всех обработчиков события.
              // Не учитывает выполнение кода через `requestAnimationFrame()` или `setTimeout()`.
              js: entry.processingEnd - processingStart,
              // Имя события, например, keydown или mousedown
              name: entry.name
            };
            var target = entry.target;
            if (target) {
              var tagName = (target.tagName || "").toLowerCase();
              var className = target.className && target.className.baseVal !== undefined2 ? target.className.baseVal : target.className;
              className = className ? (" " + className).replace(/\s+/g, ".") : "";
              params.target = tagName + className;
            }
            var fid = processingStart - entry.startTime;
            sendDelta("first-input", fid, params);
            observer.disconnect();
          }).observe({ type: "first-input", buffered: true });
        } catch (e) {
        }
      }
      var cumulativeLayoutShiftScore;
      function calcLayoutShiftScore() {
        if (!PerfObserver) {
          return;
        }
        var po = new PerfObserver(function(entryList) {
          var entries = entryList.getEntries();
          if (cumulativeLayoutShiftScore == null) {
            cumulativeLayoutShiftScore = 0;
          }
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (!entry.hadRecentInput) {
              cumulativeLayoutShiftScore += entry.value;
            }
          }
        });
        try {
          po.observe({ type: "layout-shift", buffered: true });
        } catch (e) {
        }
        addEventListener("visibilitychange", function onVisChange() {
          if (document.visibilityState !== "hidden") {
            return;
          }
          removeEventListener("visibilitychange", onVisChange);
          try {
            if (typeof po.takeRecords === "function") {
              po.takeRecords();
            }
            po.disconnect();
          } catch (e) {
          }
          finalizeLayoutShiftScore();
        });
        addEventListener("beforeunload", finalizeLayoutShiftScore);
      }
      function finalizeLayoutShiftScore() {
        if (cumulativeLayoutShiftScore == null) {
          return;
        }
        var score = Math.round(cumulativeLayoutShiftScore * 1e6) / 1e6;
        sendCounter(TECH_PERF_CLS, commonVars.concat("s=" + score));
        cumulativeLayoutShiftScore = null;
      }
      var largestContentfulPaint = null;
      var largestContentfulPaintEntry = null;
      var largestLoadingElementPaintSent = false;
      function calcLargestContentfulPaint() {
        if (!PerfObserver || !rum.getSetting("forcePaintTimeSending") && rum.isVisibilityChanged()) {
          return;
        }
        var po = new PerfObserver(function(entryList) {
          var entries = entryList.getEntries();
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            largestContentfulPaint = entry.renderTime || entry.loadTime;
            largestContentfulPaintEntry = entry;
          }
          if (!largestLoadingElementPaintSent) {
            sendTimeMark("largest-loading-elem-paint", largestContentfulPaint);
            largestLoadingElementPaintSent = true;
          }
        });
        try {
          po.observe({ type: "largest-contentful-paint", buffered: true });
        } catch (e) {
        }
        addEventListener("visibilitychange", function onVisChange() {
          if (document.visibilityState !== "hidden") {
            return;
          }
          removeEventListener("visibilitychange", onVisChange);
          try {
            if (typeof po.takeRecords === "function") {
              po.takeRecords();
            }
            po.disconnect();
          } catch (e) {
          }
          finalizeLargestContentfulPaint();
        });
        addEventListener("beforeunload", finalizeLargestContentfulPaint);
      }
      function finalizeLargestContentfulPaint() {
        if (largestContentfulPaint == null) {
          return;
        }
        var additionalParams = rum.getLCPAdditionalParams(largestContentfulPaintEntry);
        sendTimeMark("largest-contentful-paint", largestContentfulPaint, false, additionalParams);
        largestContentfulPaint = null;
        largestContentfulPaintEntry = null;
      }
      var sendElementTiming = PerfObserver ? function() {
        if (!rum.getSetting("forcePaintTimeSending") && rum.isVisibilityChanged()) {
          return;
        }
        try {
          new PerfObserver(function(entryList) {
            var entries = entryList.getEntries();
            for (var i = 0; i < entries.length; i++) {
              var entry = entries[i];
              sendTimeMark("element-timing." + entry.identifier, entry.startTime);
            }
          }).observe({ type: "element", buffered: true });
        } catch (e) {
        }
      } : function() {
      };
      function checkLongTasks(name, start, subPage) {
        if (!rum._tti) {
          return;
        }
        var currTime = getTime();
        var sendLongTasks = function(time) {
          var longTasks = rum._tti.events || [];
          var markParams = {
            "2796.2797": getLongtasksStringValue(longTasks, start),
            // long-task.value
            "689.2322": normalize(currTime)
            // action.start_time
          };
          if (subPage) {
            Object.keys(subPage).forEach(function(paramName) {
              markParams[paramName] = subPage[paramName];
            });
          }
          sendTimeMark(name || "2795", time, true, markParams);
          rum._tti.fired = true;
        };
        onQuietWindow(sendLongTasks, start);
      }
      function onQuietWindow(cb, start) {
        if (!rum._tti) {
          return;
        }
        if (!start) {
          start = getTime();
        }
        function check() {
          var maybeFCI = start;
          var now = getTime();
          var longTasks = rum._tti.events || [];
          var longTasksLength = longTasks.length;
          var lastLongTask;
          if (longTasksLength !== 0) {
            lastLongTask = longTasks[longTasksLength - 1];
            maybeFCI = Math.max(maybeFCI, Math.floor(lastLongTask.startTime + lastLongTask.duration));
          }
          if (now - maybeFCI >= LONG_TASK_TIMEOUT) {
            cb(maybeFCI);
          } else {
            setTimeout(check, 1e3);
          }
        }
        check();
      }
      rum.sendTTI = checkLongTasks;
      rum.sendHeroElement = function(time) {
        sendTimeMark("2876", time);
      };
      rum._subpages = {};
      rum.makeSubPage = function(pageName, start) {
        var index = rum._subpages[pageName];
        if (typeof index === "undefined") {
          rum._subpages[pageName] = index = 0;
        } else {
          rum._subpages[pageName] = ++index;
        }
        var canceled = false;
        return {
          "689.2322": normalize(typeof start !== "undefined" ? start : getTime()),
          // action.start_time
          "2924": pageName,
          // bs: subpage_name
          "2925": index,
          // bs: subpage_index
          isCanceled: function() {
            return canceled;
          },
          cancel: function() {
            canceled = true;
          }
        };
      };
      function pushConnectionTypeTo(vars) {
        if (connection) {
          vars.push(
            // [connection_type] Тип соединения. MDN: https://clck.ru/AASTf
            // 2771 – invalid
            "2437=" + (CONNECTION_TYPES[connection.type] || 2771),
            // [downlink_max] Максимальная скорость соединения. MDN: https://clck.ru/AASYS
            connection.downlinkMax !== undefined2 && "2439=" + connection.downlinkMax,
            // [effective_type] Оценка реального качества соединения. MDN: https://clck.ru/C5hCb
            connection.effectiveType && "2870=" + connection.effectiveType,
            // Характеристики сети
            connection.rtt !== undefined2 && "rtt=" + connection.rtt,
            connection.downlink !== undefined2 && "dwl=" + connection.downlink
          );
        }
      }
      function getResourceTimings(url, cb) {
        if (!hasGetEntriesByType) {
          return cb(null);
        }
        normalizeLink.href = url;
        var normalizedUrl = normalizeLink.href;
        var pollingIteration = 0;
        var timeBeforeNextPolling = 100;
        function tryToGetResTiming() {
          var resTimings = perf.getEntriesByName(normalizedUrl);
          if (resTimings.length) {
            return cb(resTimings);
          }
          if (pollingIteration++ < POLLING_ITERATIONS_LIMIT) {
            setTimeout(tryToGetResTiming, timeBeforeNextPolling);
            timeBeforeNextPolling += timeBeforeNextPolling;
          } else {
            cb(null);
          }
        }
        setTimeout(tryToGetResTiming, 0);
      }
      function getLongtasksStringValue(longtasks, start) {
        longtasks = longtasks || [];
        start = start || 0;
        return longtasks.filter(function(longtask) {
          return longtask.startTime - start >= -50;
        }).map(function(longtask) {
          var name = longtask.name ? longtask.name.split("-").map(function(el) {
            return el[0];
          }).join("") : "u";
          var start2 = Math.floor(longtask.startTime), end = Math.floor(start2 + longtask.duration);
          return name + "-" + start2 + "-" + end;
        }).join(".");
      }
      rum._getLongtasksStringValue = getLongtasksStringValue;
      function getMarkCommonVars(counterId) {
        return markCommonVars.concat([
          "1701=" + counterId,
          // id – идентификатор счётчика
          rum.ajaxStart && "1201.2154=" + normalize(rum.ajaxStart),
          // ajax.start
          rum.ajaxComplete && "1201.2052=" + normalize(rum.ajaxComplete)
          // ajax.success
        ]);
      }
      function pushTimingTo(vars, timing) {
        Object.keys(COMMON_TIMING_PROPS_MAP).forEach(function(name) {
          if (name in timing) {
            var time = timing[name];
            if (time || time === 0) {
              vars.push(COMMON_TIMING_PROPS_MAP[name] + "=" + normalize(time));
            }
          }
        });
      }
      function normalize(x, offset) {
        return typeof x === "string" ? encodeURIComponent(x) : Math.round((x - (offset || 0)) * 1e3) / 1e3;
      }
      function sendCounter(path, varsArr) {
        var cdnLocation = encodeURIComponent(window.YaStaticRegion || "unknown");
        varsArr.push("-cdn=" + cdnLocation);
        var vars = varsArr.filter(Boolean).join(",");
        rum.send(null, path, vars);
      }
      rum.getResourceTimings = getResourceTimings;
      rum.pushConnectionTypeTo = pushConnectionTypeTo;
      rum.pushTimingTo = pushTimingTo;
      rum.normalize = normalize;
      rum.sendCounter = sendCounter;
      rum.sendDelta = sendDelta;
      rum.sendTrafficData = sendTrafficData;
      rum.finalizeLayoutShiftScore = finalizeLayoutShiftScore;
      rum.finalizeLargestContentfulPaint = finalizeLargestContentfulPaint;
      rum.onReady = onReady;
      rum.onQuietWindow = onQuietWindow;
    })(Ya.Rum);
  }
});

// node_modules/@yandex-int/error-counter/dist/interfaceOverRum.js
var require_interfaceOverRum = _chunkQ4G2SZRDjs.__commonJS.call(void 0, {
  "node_modules/@yandex-int/error-counter/dist/interfaceOverRum.js"() {
    "use strict";
    (function(window2) {
      if (!(window2.Ya && Ya.Rum)) {
        throw new Error("Rum: interface is not defined");
      }
      var rum = Ya.Rum;
      rum.getSetting = function(settingName) {
        var setting = rum._settings[settingName];
        return setting === null ? null : setting || "";
      };
    })(typeof self !== "undefined" ? self : window);
  }
});

// node_modules/@yandex-int/error-counter/dist/filters.js
var require_filters = _chunkQ4G2SZRDjs.__commonJS.call(void 0, {
  "node_modules/@yandex-int/error-counter/dist/filters.js"() {
    "use strict";
    (function(rum) {
      var filters = {
        url: {
          // Ошибки API расширений браузеров.
          "0": /(miscellaneous|extension)_bindings/,
          // Ошибки из внутренних элементов браузера Chrome.
          "1": /^chrome:/,
          // Ошибки из расширения Kaspersky Protection.
          "2": /kaspersky-labs\.com\//,
          // Ошибки из расширений браузеров
          "3": /^(?:moz|chrome|safari)-extension:\/\//,
          // Ошибки из пользовательских файлов.
          "4": /^file:/,
          // Ошибки в подгружаемых ресурсах (типа дополнительных скриптов расширений или Java-апплетов в Firefox)
          "5": /^resource:\/\//,
          // Ошибки в сеошном расширении https://nda.ya.ru/3UVNQe
          "6": /webnetc\.top/,
          // Ошибки AdGuard
          "7": /local\.adguard\.com/
        },
        message: {
          // Ошибки AdGuard.
          "0": /__adgRemoveDirect/,
          // Ошибки в CSP.
          "1": /Content Security Policy/,
          // Ошибки vid_mate_check is not defined
          "2": /vid_mate_check/,
          // Ошибки UC Browser.
          "3": /ucapi/,
          // Ошибки при обращении к элементам айфреймов в IE
          "4": /Access is denied/i,
          // Ошибки при обращении к элементам айфреймов
          "5": /^Uncaught SecurityError/i,
          // Ошибки Can't find variable: __ybro
          "6": /__ybro/,
          // Ошибки ReferenceError: __show__deepen is not defined
          "7": /__show__deepen/,
          // ntp is not defined
          "8": /ntp is not defined/,
          // Cannot set property 'install' of undefined
          "9": /Cannot set property 'install' of undefined/,
          // Внутренние ошибки файерфокса
          "10": /NS_ERROR/,
          // Ошибка загрузки скриптов по какой-либо причине (сетевые проблемы?)
          "11": /Error loading script/,
          // TypeError: undefined is not a function
          "12": /^TypeError: undefined is not a function$/,
          // https://st.yandex-team.ru/SERP-78992
          // ошибка Firefox/iOS 8,9,10 https://bugzilla.mozilla.org/show_bug.cgi?id=1394296
          "13": /__firefox__\.(?:favicons|metadata|reader|searchQueryForField|searchLoginField)/
        },
        stack: {
          // Ошибки из расширений браузеров
          "0": /(?:moz|chrome|safari)-extension:\/\//,
          // ошибки AdGuard в тех браузерах, которые показывают файлы расширений в стеке
          "1": /adguard.*\.user\.js/i
        }
      };
      function isExternalError(url, message, stack) {
        var customFilters = rum._errorSettings.filters || {};
        var currErrorPlaces = {
          url: (url || "") + "",
          message: (message || "") + "",
          stack: (stack || "") + ""
        };
        var commonFiltersStrs = collectExternalErrorInner(currErrorPlaces, filters);
        var customFiltersStrs = collectExternalErrorInner(currErrorPlaces, customFilters);
        return {
          common: commonFiltersStrs,
          custom: customFiltersStrs,
          hasExternal: !!(commonFiltersStrs || customFiltersStrs)
        };
      }
      function checkExternalErrorInner(str, errorItems) {
        if (!str || !errorItems) {
          return;
        }
        var result = [];
        for (var errorId in errorItems) {
          if (errorItems.hasOwnProperty(errorId)) {
            var regexp = errorItems[errorId];
            if (typeof regexp === "string") {
              regexp = new RegExp(regexp);
            }
            if (regexp instanceof RegExp && regexp.test(str)) {
              result.push(errorId);
            }
          }
        }
        return result.join("_");
      }
      function collectExternalErrorInner(currErrorPlaces, errorItems) {
        var filtersStrs = [];
        var strs;
        for (var errorPlace in filters) {
          if (filters.hasOwnProperty(errorPlace)) {
            strs = checkExternalErrorInner(currErrorPlaces[errorPlace], errorItems[errorPlace]);
            if (strs) {
              filtersStrs.push(errorPlace + "~" + strs);
            }
          }
        }
        return filtersStrs.join(";");
      }
      rum._isExternalError = isExternalError;
    })(Ya.Rum);
  }
});

// src/rum/index.ts
var _uuid = require('uuid');

// node_modules/@yandex-int/rum-counter/dist/inline/interface.js
(function(window2, undefined2) {
  window2.Ya = window2.Ya || {};
  if (Ya.Rum) {
    throw new Error("Rum: interface is already defined");
  }
  var perf = window2.performance;
  var navStart = perf && perf.timing && perf.timing.navigationStart || Ya.startPageLoad || +/* @__PURE__ */ new Date();
  var requestAnimationFrame = window2.requestAnimationFrame;
  var rum = Ya.Rum = {
    // флаг для проверки работоспособности счетчика
    // eslint-disable-next-line no-implicit-coercion
    enabled: !!perf,
    // Видимость документа в начале загрузки
    vsStart: document.visibilityState,
    // Менялась ли видимость документа document.visibilityState в процессе загрузки
    vsChanged: false,
    // список временных меток для дальнейшей отправки
    _defTimes: [],
    // список меток ресурсов для дальнейшей отправки
    _defRes: [],
    // список рассчитанных с помощью time()..timeEnd() дельт
    _deltaMarks: {},
    // список обработчиков, подписанных на срабатывание меток
    _markListeners: {},
    /**
     * Настройки RUM
     *
     * @typedef {Object} RUMSettings
     */
    _settings: {},
    /**
     * Произвольные параметры, пробрасываемые в логи.
     *
     * @typedef {Object<BlockStatID, String|BlockStatID>} Vars – Объект с параметрами
     * @example
     * {
     *     "143": "28.1786",
     *     "1042": "Example%20User%20Agent%201.0"
     * }
     */
    _vars: {},
    /**
     * Инициализация интерфейса.
     *
     * @param {RUMSettings} settings – Настройки RUM
     * @param {Vars} vars
     */
    init: function(settings, vars) {
      rum._settings = settings;
      rum._vars = vars;
    },
    /**
     * Получить время от начала навигации.
     *
     * @returns {Number}
     */
    getTime: perf && perf.now ? function() {
      return perf.now();
    } : Date.now ? function() {
      return Date.now() - navStart;
    } : function() {
      return /* @__PURE__ */ new Date() - navStart;
    },
    /**
     * Записывает время старта расчёта дельты.
     *
     * @param {String} counterId - Код BlockStat. ID метки времени
     */
    time: function(counterId) {
      rum._deltaMarks[counterId] = [rum.getTime()];
    },
    /**
     * Записывает время окончания расчёта дельты.
     * При загрузке RUM implementation записанные метрики будут отправлены на бэкэнд.
     *
     * @param {String} counterId - Код BlockStat. ID метки времени
     * @param {Object} [params=null] - Кастомные параметры дельты. Сюда же можно передать инстанс подстраницы
     */
    timeEnd: function(counterId, params) {
      var deltaMarks = rum._deltaMarks, deltaTimes = deltaMarks[counterId];
      if (!deltaTimes || deltaTimes.length === 0) {
        return;
      }
      deltaTimes.push(rum.getTime(), params);
    },
    /**
     * Отправить счетчик с временной меткой.
     *
     * @param {String} counterId  - Код BlockStat. ID метки времени
     * @param {Number} [time] - Время. Если не передано, вычисляется время
     *     от начала навигации до момента вызова функции
     * @param {Boolean} [addPerfMark=true] - Добавлять метку в User Timing или нет, true по умолчанию
     * @param {Object} [params=null] - Кастомные параметры счетчика. Сюда же можно передать инстанс подстраницы
     */
    sendTimeMark: function(counterId, time, addPerfMark, params) {
      if (time === undefined2) {
        time = rum.getTime();
      }
      rum._defTimes.push([counterId, time, params]);
      rum.mark(counterId, time);
    },
    /**
     * Отправить счетчик с дельтой времени.
     *
     * @param {String} counterId - Код BlockStat. ID метки времени
     * @param {Number} [delta] - Точное значение дельты
     * @param {Object} [params=null] - Кастомные параметры дельты. Сюда же можно передать инстанс подстраницы
     */
    sendDelta: function(counterId, delta, params) {
      var deltaMarks = rum._deltaMarks;
      if (!deltaMarks[counterId] && typeof delta !== "undefined") {
        var deltaEnd = rum.getTime();
        deltaMarks[counterId] = [deltaEnd - delta, deltaEnd, params];
      }
    },
    /**
     * Заглушка отправки временных меток ресурса,
     * откладывает отправку до загрузки основного кода.
     *
     * @param {String|Number} counterId
     * @param {String} url
     */
    sendResTiming: function(counterId, url) {
      rum._defRes.push([counterId, url]);
    },
    /**
     * Отправить тайминги requestAnimationFrame.
     *
     * @param {String|Number} position – blockStat-код позиции счётчика, например 85 – p0
     */
    sendRaf: function(position) {
      var forcePaintTimeSending = rum.getSetting("forcePaintTimeSending");
      if (!requestAnimationFrame || !forcePaintTimeSending && rum.isVisibilityChanged()) {
        return;
      }
      var prefix = "2616." + position;
      requestAnimationFrame(function() {
        if (!forcePaintTimeSending && rum.isVisibilityChanged()) {
          return;
        }
        if (rum.getSetting("sendFirstRaf")) {
          rum.sendTimeMark(prefix + ".205");
        }
        requestAnimationFrame(function() {
          if (!forcePaintTimeSending && rum.isVisibilityChanged()) {
            return;
          }
          rum.sendTimeMark(prefix + ".1928");
        });
      });
    },
    /**
     * Проверяет, изменялась ли видимость страницы при загрузке.
     *
     * @returns {Boolean}
     */
    isVisibilityChanged: function() {
      return rum.vsStart && (rum.vsStart !== "visible" || rum.vsChanged);
    },
    /**
     * Поставить метку времени в User Timing https://www.w3.org/TR/user-timing/#dom-performance-mark
     * В браузерах, не поддерживающих window.performance.mark(), заменяется ничего не делающей заглушкой.
     *
     * @param {String} name - Код BlockStat. ID метки времени
     * @param {Number} [time] - Время. Опционально, нужно для сверки со временем, которое ставит
     *     само User Timing API, или для меток, которые ставятся "задним числом" (ttfb, ttfp etc.)
     */
    mark: perf && perf.mark ? function(name, time) {
      perf.mark(name + (time ? ": " + time : ""));
    } : function() {
    },
    /**
     * Получить значение настройки.
     *
     * @param {String} settingName
     * @returns {*|String}
     */
    getSetting: function(settingName) {
      var setting = rum._settings[settingName];
      return setting === null ? null : setting || "";
    },
    /**
     * Подписаться на срабатывание временной метки
     *
     * @param {String} counterId
     * @param {Function} cb
     */
    on: function(counterId, cb) {
      if (typeof cb !== "function")
        return;
      (rum._markListeners[counterId] = rum._markListeners[counterId] || []).push(cb);
    },
    /**
     * Отправить данные о трафике
     */
    sendTrafficData: function() {
    },
    /**
     * Отправить текущее значение CLS и начать считать заново
     */
    finalizeLayoutShiftScore: function() {
    },
    /**
     * Отправить текущее значение LCP и начать искать заново
     */
    finalizeLargestContentfulPaint: function() {
    },
    /**
     * Получить дополнительные параметры, которые будут залогированы вместе с LCP
     */
    getLCPAdditionalParams: function() {
    }
  };
  function onVisibilityChange() {
    Ya.Rum.vsChanged = true;
    document.removeEventListener("visibilitychange", onVisibilityChange);
  }
  if (document.addEventListener) {
    document.addEventListener("visibilitychange", onVisibilityChange);
  }
})(window);

// node_modules/@yandex-int/rum-counter/dist/inline/longtask.js
(function() {
  if (window.PerformanceLongTaskTiming) {
    var MAX_EVENTS_COUNT = 300, addEvents = function(events, entries) {
      events = events.concat(entries);
      if (events.length > MAX_EVENTS_COUNT) {
        events = events.slice(events.length - MAX_EVENTS_COUNT);
      }
      return events;
    }, inst = Ya.Rum._tti = {
      /**
       * Массив последних событий longtask, количество ограничено числом MAX_EVENTS_COUNT
       */
      events: [],
      eventsAfterTTI: [],
      fired: false,
      observer: new PerformanceObserver(function(tasks) {
        var entries = tasks.getEntries();
        inst.events = addEvents(inst.events, entries);
        if (inst.fired) {
          inst.eventsAfterTTI = addEvents(inst.eventsAfterTTI, entries);
        }
      })
    };
    inst.observer.observe({
      entryTypes: ["longtask"]
    });
  }
})();

// node_modules/@yandex-int/rum-counter/dist/inline/io.js
Ya.Rum.observeDOMNode = window.IntersectionObserver ? function(counterID, target, ioOptions) {
  var that = this, forcePaintTimeSending = Ya.Rum.getSetting("forcePaintTimeSending");
  function check() {
    if (!forcePaintTimeSending && that.isVisibilityChanged()) {
      return;
    }
    var domNode = typeof target === "string" ? document.querySelector(target) : target;
    if (domNode) {
      new IntersectionObserver(function(entries, observer) {
        if (!forcePaintTimeSending && that.isVisibilityChanged()) {
          return;
        }
        Ya.Rum.sendTimeMark(counterID);
        observer.unobserve(domNode);
      }, ioOptions).observe(domNode);
    } else {
      setTimeout(check, 100);
    }
  }
  check();
} : function() {
};

// node_modules/@yandex-int/rum-counter/dist/bundle/onload.js
(function() {
  if (Ya.Rum.enabled && !Ya.Rum._onloadCounterInited) {
    Ya.Rum._onloadCounterInited = true;
    if (document.readyState === "complete") {
      onload();
    } else {
      addEventListener("load", onload);
    }
  }
  function onload() {
    removeEventListener("load", onload);
    var rum = Ya.Rum;
    rum.sendTimeMark("1724");
    if (!rum.getSetting("sendAutoResTiming")) {
      return;
    }
    var resources = document.querySelectorAll("script[data-rCid], div[data-rCid]");
    for (var i = 0, len = resources.length; i < len; i++) {
      var resource = resources[i], src = resource.src;
      if (!src) {
        var bg = getComputedStyle(resource).backgroundImage;
        if (bg) {
          var url = bg.match(/^url\(["']?(.*?)["']?\)$/);
          if (url) {
            src = url[1];
          }
        }
      }
      if (src) {
        rum.sendResTiming(resource.getAttribute("data-rCid"), src);
      }
    }
  }
})();

// node_modules/@yandex-int/rum-counter/dist/bundle/send.js
(function() {
  var MAX_BATCH_COUNTERS = 42;
  var COUNTERS_BATCH_TIMEOUT = 15;
  var countersBatchData = [];
  var counterTimerId;
  Ya.Rum.send = function(link, path, vars, clck, tree, sts, counterParams) {
    clearTimeout(counterTimerId);
    var slots = Ya.Rum.getSetting("slots");
    var experiments = Ya.Rum.getSetting("experiments");
    var counterSections = [
      // reqid добавляется на случай попадания в батч счётчиков из разных запросов – например, после аякса
      "/reqid=" + Ya.Rum.getSetting("reqid"),
      counterParams ? "/" + counterParams.join("/") : "",
      path ? "/path=" + path : "",
      tree ? "/events=" + tree : "",
      slots ? "/slots=" + slots.join(";") : "",
      experiments ? "/experiments=" + experiments.join(";") : "",
      vars ? "/vars=" + vars : "",
      "/cts=" + (/* @__PURE__ */ new Date()).getTime(),
      "/*"
    ];
    countersBatchData.push(counterSections.join(""));
    if (countersBatchData.length < MAX_BATCH_COUNTERS) {
      counterTimerId = setTimeout(sendBatchRequest, COUNTERS_BATCH_TIMEOUT);
    } else {
      sendBatchRequest();
    }
  };
  function sendBatchRequest() {
    var clck = Ya.Rum.getSetting("clck"), data = countersBatchData.join("\r\n");
    countersBatchData = [];
    counterTimerId = null;
    if (!clck) {
      return;
    }
    var sendBeaconPostAvailable = navigator.sendBeacon && Ya.Rum.getSetting("beacon"), sendBeaconResult = sendBeaconPostAvailable && navigator.sendBeacon(clck, data);
    if (!sendBeaconResult) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", clck);
      xhr.send(data);
    }
  }
})();

// src/rum/index.ts
var import_logError = _chunkQ4G2SZRDjs.__toESM.call(void 0, require_logError());
var import_implementation = _chunkQ4G2SZRDjs.__toESM.call(void 0, require_implementation());
function rumInit({ page, project = "pythia", tld, slots, version = "local" }) {
  const reqid = _uuid.v4.call(void 0, );
  window.Ya.Rum.init(
    {
      beacon: true,
      clck: "https://yandex.ru/clck/click",
      reqid,
      slots
    },
    {
      // eslint-disable-next-line camelcase
      rum_id: `${tld}.${project}.${page}`,
      region: String(_chunkBYIEAVCXjs.getRegionIdByTLD.call(void 0, tld)),
      "-project": project,
      "-page": page,
      "-version": version
    }
  );
  require_implementation2();
}
function initCounters({
  page,
  project = "pythia",
  tld,
  slots,
  version = "local",
  env
}) {
  const reqid = _uuid.v4.call(void 0, );
  window.Ya.Rum.init(
    {
      beacon: true,
      clck: "https://yandex.ru/clck/click",
      reqid,
      slots
    },
    {
      // eslint-disable-next-line camelcase
      rum_id: `${tld}.${project}.${page}`,
      region: String(_chunkBYIEAVCXjs.getRegionIdByTLD.call(void 0, tld)),
      "-project": project,
      "-page": page,
      "-version": version
    }
  );
  require_implementation2();
  require_interfaceOverRum();
  require_implementation();
  require_filters();
  require_logError();
  window.Ya.Rum.initErrors({
    reqid,
    project,
    page,
    env: env || process.env.NODE_ENV === "local" ? "development" : "production",
    version,
    preventError: true,
    // Останавливает всплытие ошибки
    unhandledRejection: true
    // Отлавливать Unhandled rejection
  });
}
function sendFirstMeaningfulPaint(selector) {
  if (selector) {
    window.Ya.Rum.observeDOMNode("2876", selector);
  } else {
    window.Ya.Rum.sendHeroElement();
  }
}
function sendJSFrameworkInited() {
  window.Ya.Rum.sendTimeMark("3036");
}
function isAvailable() {
  return Ya && Ya.Rum && typeof Ya.Rum.logError === "function";
}
function logError({
  message,
  err,
  additional,
  level = "error",
  type = "logic"
}) {
  if (!isAvailable()) {
    console.error(err);
    return;
  }
  Ya.Rum.logError(
    _chunkQ4G2SZRDjs.__spreadProps.call(void 0, _chunkQ4G2SZRDjs.__spreadValues.call(void 0, {
      message,
      level
    }, additional && { additional }), {
      type
    }),
    err
  );
}







exports.rumInit = rumInit; exports.initCounters = initCounters; exports.sendFirstMeaningfulPaint = sendFirstMeaningfulPaint; exports.sendJSFrameworkInited = sendJSFrameworkInited; exports.logError = logError;
//# sourceMappingURL=chunk-FBR6Y46Z.js.map